import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Grid"; // Grid version 1
import Card from "@mui/material/Card";
import { Header } from "./components/Header";
import CardMedia from "@mui/material/CardMedia";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";
import Alert from "@mui/material/Alert";

function App() {
  const [data, setData] = useState(null);

  useEffect(() => {
    fetch(
      "https://api.wordpress.org/plugins/info/1.2/?action=query_plugins&request[author]=haritpanchal"
    )
      .then((response) => response.json())
      .then((data) => setData(data))
      .catch((error) => console.error(error));
  }, []);

  // console.log(data.plugins);
  const plugins = data ? data.plugins : "";
  const pluginsGrid = plugins
    ? plugins.map((plugin) => {
        const active_installs =
          plugin.active_installs > 10
            ? plugin.active_installs + "+"
            : "Less than 10";
        console.log(plugin);
        return (
          <Grid item xs={6}>
            <Card variant="outlined" sx={{ maxWidth: 500 }}>
              <a
                target="_blank"
                href={"https://wordpress.org/plugins/" + plugin.slug}
                rel="noreferrer"
              >
                <CardMedia
                  sx={{ height: 250 }}
                  component="img"
                  alt={plugin.slug}
                  image={
                    plugin.icons.svg ? plugin.icons.svg : plugin.icons.default
                  }
                  style={{ opacity: "0.75" }}
                />{" "}
              </a>
              <CardContent>
                <p>
                  <a
                    target="_blank"
                    className="plugin-name"
                    rel="noreferrer"
                    href={"https://wordpress.org/plugins/" + plugin.slug}
                  >
                    {plugin.name}
                  </a>
                </p>
                <p>
                  <b>Released Date:</b> {plugin.added}
                </p>
                <p>
                  <b>Active Installs:</b> {active_installs}{" "}
                </p>
                <p>
                  <b>Download Count:</b> {plugin.downloaded}
                </p>
                <p>
                  <b>Description: </b> {plugin.short_description}
                </p>
                <Button
                  variant="contained"
                  href={plugin.download_link}
                  style={{ backgroundColor: "#3d9845" }}
                >
                  Download
                </Button>
              </CardContent>
            </Card>
          </Grid>
        );
      })
    : "Loading..";

  return (
    <>
      <Grid container spacing={2}>
        <Header />
      </Grid>
      <Alert severity="info">
        <strong>WordPress Plugin Developement</strong>
      </Alert>
      <Grid className="detail" container spacing={2}>
        {pluginsGrid}
      </Grid>
    </>
  );
}

export default App;
